__turbopack_context__.v({
  "cost-with-icon": "index-module-scss-module__TwzRQa__cost-with-icon",
  "icon-wrapper": "index-module-scss-module__TwzRQa__icon-wrapper",
  "payment-info": "index-module-scss-module__TwzRQa__payment-info",
  "payment-methods": "index-module-scss-module__TwzRQa__payment-methods",
  "subtitle-with-icon": "index-module-scss-module__TwzRQa__subtitle-with-icon",
});
